/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    ADDONS_RECEIVE,
    ADDONS_REQUEST,
    ADDONS_REQUEST_SUCCESS,
    ADDONS_REQUEST_FAILURE
} from 'state/action-types';

export const items = createReducer([], {
    [ADDONS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [ADDONS_REQUEST]: () => true,
    [ADDONS_REQUEST_SUCCESS]: () => false,
    [ADDONS_REQUEST_FAILURE]: () => false,
});

export const error = createReducer(false, {
    [ADDONS_REQUEST]: () => false,
    [ADDONS_REQUEST_SUCCESS]: () => false,
    [ADDONS_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
